"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.delete.confirm.title': 'Usuń Pytanie',
    'question.delete.confirm.message': 'Czy na pewno chcesz usunąć to pytanie?',
};
